import { useState } from "react";
import styles from "./Performances.module.css";
import { Tabs, Tab } from "@mui/material";
import GlobalIcon from "../GlobalIcon/GlobalIcon";

function Performances({ data = {} }) {
  const [activeTab, setActiveTab] = useState("ALL");

  const tabs = ["ALL", "Top Gainers", "Top Losers", "Volume", "Heat map"];

  // Get data for current active tab
  const currentTabData = data[activeTab] || [];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className={styles["performances"]}>
      {/* Header */}
      <div className={styles["performances-header"]}>
        <div className={styles["performances-title-container"]}>
          <div className={styles["performances-icon"]}>
            <GlobalIcon
              iconName="cardLabelIcon"
              className={styles["performances-icon-svg"]}
            />
          </div>
          <h2 className={styles["performances-title"]}>Performances</h2>
        </div>
      </div>

      {/* Tabs */}
      <div className={styles["performances-tabs-container"]}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
        >
          {tabs.map((tab) => (
            <Tab key={tab} label={tab} value={tab} disableRipple />
          ))}
        </Tabs>
      </div>

      {/* Table Container */}
      <div className={styles["performances-table-container"]}>
        <table className={styles["performances-table"]}>
          <thead>
            <tr>
              <th className={styles["table-header"]}>Security Code</th>
              <th className={styles["table-header"]}>Security Name</th>
              <th className={styles["table-header"]}>LTP</th>
              <th className={styles["table-header"]}>Change</th>
              <th className={styles["table-header"]}>%Chg</th>
            </tr>
          </thead>
          <tbody>
            {currentTabData.length > 0 ? (
              currentTabData.map((row, index) => (
                <tr key={index} className={styles["table-row"]}>
                  <td className={styles["table-cell"]}>{row.securityCode}</td>
                  <td className={styles["table-cell"]}>{row.securityName}</td>
                  <td className={styles["table-cell"]}>{row.ltp}</td>
                  <td
                    className={`${styles["table-cell"]} ${
                      row.changeIsPositive
                        ? styles["positive"]
                        : styles["negative"]
                    }`}
                  >
                    {row.change}
                  </td>
                  <td
                    className={`${styles["table-cell"]} ${
                      row.changeIsPositive
                        ? styles["positive"]
                        : styles["negative"]
                    }`}
                  >
                    {row.percentageChange}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className={styles["table-empty"]}>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Performances;

